import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { SessionTopicSpecialist } from '@interfaces';
import { DomainDataService } from '../../../../../../services';
import { AccSessionViewerDialogDataService } from '../../acc-session-viewer-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';

export function getSetup(service: AccSessionViewerDialogDataService, util: UtilityService, dialogService: DialogService, domainData: DomainDataService): GridSetup<SessionTopicSpecialist & { updatedUTC: number }> {

	return {
		rowName: { singular: 'Sign-Up', plural: 'Sign-Ups' },
		getRowKey: row => '' + row.volunteerId,
		stateKey: 'acc-session-sign-ups',
		actions: getActions(service, dialogService),
		buttons: getButtons(service),
		columns: getColumns(util, domainData),
	}
}
